//React Components and Hooks
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
//Material UI Components
import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import Skeleton from "@mui/material/Skeleton";
import React from "react";
//Context
//Custom Components
import Header from "./Header";
import Row from "./Row";

const UbilTable = (props) => {
  const {
    columns,
    data,
    rowType,
    destination,
    linkField,
    deleteField,
    deleteFunction,
    paginated,
    isLoading,
  } = props;
  console.log("TableComponenet: Table Props =");
  console.log(props);
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      minHeight: 440,
      maxHeight: 440,
    },
  }));
  const classes = useStyles();

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let deletions = [];
  const addDeletion = (deletionField) => {
    deletions.push(deletionField);
  };
  const removeDeletion = (deletionField) => {
    deletions = deletions.filter((deletion) => {
      return deletion !== deletionField;
    });
  };
  const deleteSubmissionHandler = async () => {
    await deleteFunction(deletions);
    deletions = [];
  };
  console.log("TableComponenet: Rendering Table");
  console.log(props.data);
  if (isLoading) {
    console.log("TableComponenet: Is in loading state!");
    /*return (
      <Skeleton animation="wave" variant="rect" width="100%" height="440px" style={{ backgroundColor: `grey` }} />
    )*/
    return (
      <Paper style={{ padding: 6 }}>
        <Skeleton
          variant="rectangular"
          height="60px"
          sx={{ 
            bgcolor: 'action.hover',
            m: 0.75,
            mb: 1
          }}
        />
        {[...Array(4)].map((_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            height="50px"
            sx={{
              bgcolor: 'action.hover',
              m: 0.75,
              mb: 0.375
            }}
          />
        ))}
      </Paper>
    );
  }
  console.log("TableComponenet: Loading Complete, rendering");
  return (
    <Paper>
      <TableContainer className={classes.root}>
        <Table stickyHeader aria-label="collapsible table">
          <TableHead>
            <Header columns={columns} />
          </TableHead>
          <TableBody className={classes.container}>
            {paginated && data.length > 0
              ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((rowData, index) => (
                  <Row
                    key={index}
                    columns={columns}
                    data={rowData}
                    rowType={rowType || null}
                    destination={destination}
                    linkField={linkField}
                    deleteField={deleteField}
                    deleteFunction={() => addDeletion(rowData[deleteField])}
                    cancelDeleteFunction={() =>
                      removeDeletion(rowData[deleteField])
                    }
                  />
                ))
              : data.length > 0 &&
                data.map((rowData, index) => (
                  <Row
                    key={index}
                    columns={columns}
                    data={rowData}
                    rowType={rowType || null}
                    destination={destination}
                    linkField={linkField}
                    deleteField={deleteField}
                    deleteFunction={() => addDeletion(rowData[deleteField])}
                    cancelDeleteFunction={() =>
                      removeDeletion(rowData[deleteField])
                    }
                  />
                ))}
          </TableBody>
        </Table>
      </TableContainer>
      {rowType === "deletable" ? (
        <Button
          onClick={deleteSubmissionHandler}
          variant="contained"
          style={{ backgroundColor: "red", color: "white" }}
        >
          CONFIRM DELETIONS
        </Button>
      ) : (
        ""
      )}
      {paginated ? (
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={data ? data.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            borderTop: '1px solid',
            borderColor: 'divider',
            '& .MuiTablePagination-toolbar': {
              paddingLeft: 2,
              paddingRight: 2,
              display: 'flex',
              alignItems: 'center',
              minHeight: '52px',
            },
            '& .MuiTablePagination-selectLabel': {
              marginRight: 1,
              marginLeft: 0,
            },
            '& .MuiTablePagination-select': {
              marginRight: 2,
              marginLeft: 1,
            },
            '& .MuiTablePagination-displayedRows': {
              marginRight: 1,
            },
            '& .MuiTablePagination-actions': {
              marginLeft: 2,
            },
          }}
          SelectProps={{
            native: true,
          }}
        />
      ) : (
        ""
      )}
    </Paper>
  );
};

export default UbilTable;
